<template>
  <div class="container">
    <div class="loader" v-if="this.dataloading">
      <div class="loader-inner ball-scale-multiple">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <section v-else class="content-wrap top__article">
      <div class="c-section fill-align">
        <div class="sectionHeader">
          <h2 class="title">{{ $t("Customize Interest") }}</h2>
          <a
            href="javascript:;"
            @click="_saveInterestList"
            class="btn btn-green save_interest"
            id="save_interest"
            >{{ $t("保存する") }}</a
          >
        </div>

        <div class="set-itemList">
          <ul class="c-horizontalList" v-if="categories.length">
            <li
              class="c-post "
              v-for="(category, index) in categories"
              :key="index"
              v-bind:class="isSelectedCategory(category.category_id)"
              @click="_selectInterest(category.category_id)"
            >
              <div class="thumb c-ratioBox" style="padding-bottom: 62.5%">
                <div class="c-content">
                  <h3 class="title">{{ category.category_name }}</h3>
                </div>
                <img
                  class="lazyloaded"
                  :data-src="category.image.small"
                  :alt="category.category_name"
                  :src="category.image.small"
                />

                <div
                  class="c-post-active"
                  v-if="isSelectedCategory(category.category_id)"
                >
                  <span class="checkmark">
                    <div class="checkmark_circle"></div>
                    <div class="checkmark_stem"></div>
                    <div class="checkmark_kick"></div>
                  </span>
                </div>
              </div>
              <div class="line-content"></div>
            </li>
          </ul>
          <ul v-else class="no-clip">
            <h3 class="empty-artcile">No data found!</h3>
          </ul>
        </div>
      </div>
      <a
        href="javascript:;"
        @click="_saveInterestList"
        class="save_interest_float"
        id="save_interest"
        >Save</a
      >
    </section>
  </div>
</template>

<script>
import { defaults, post, delete as _delete } from "axios";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { getCategoryLists, getInterestList } from "@/api/user-interest";

defaults.headers.common["Accept"] = "application/json";
defaults.headers.post["Content-Type"] = "application/json";
const loader = document.getElementById("loading");

export default {
  mounted() {
    // Refresh ID Token
    this.$store.dispatch("fetchSetNewToken");

    if (this.matcaCategoryList.length <= 0) {
      // Get All Category List And Assign to Computed Data
      const categories = new Promise((resolve, reject) => {
        getCategoryLists({ lang_id: this.lang_id })
          .then(response => {
            this.categories = response.data;
            resolve(response.data);
          })
          .catch(err => {
            // console.log(err)
            reject(err);
          });
      });

      // Get User Interest List And Assign to Computer Data
      const _interest = new Promise((resolve, reject) => {
        getInterestList(this.token)
          .then(res => {
            this.user_interest = res;
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });

      Promise.all([categories, _interest])
        .then(values => {
          // console.log(values)
          this.dataloading = false;
        })
        .catch(err => {
          // console.log(err)
          this.dataloading = false;
        });
    } else {
      this.categories = this.matcaCategoryList;

      getInterestList(this.token)
        .then(res => {
          this.user_interest = res;
          this.dataloading = false;
        })
        .catch(error => {
          this.dataloading = false;
        });
    }

    this.$gtm.trackView("BookmarkedArticleLists", "currentpath");
  },
  data() {
    return {
      clipList: [],
      removed_category: [],
      categories: [],
      user_interest: [],
      dataloading: true,
      languageName: this.$store.state.languageName,
      error: [],
      categoryFilterId: null
    };
  },
  computed: {
    ...mapState(["clips", "user"]),
    ...mapGetters({
      email: "email",
      token: "token",
      lang_id: "languageId",
      dataList: "articleList",
      clip_category_id: "userClipCategory",
      matcaCategoryList: "matcaCategoryList",
      userInterestList: "userInterestList",
      user_interested_category: "userInterestedCategory"
    })
  },
  methods: {
    isSelectedCategory(id) {
      return this.user_interest.indexOf(id) >= 0 ? "active" : "";
    },

    _selectInterest(d) {
      // console.log(d)
      // Remove & Add
      if (this.user_interest.indexOf(d) >= 0) {
        var index = this.user_interest.indexOf(d);

        if (index > -1) {
          this.user_interest.splice(index, 1);
        }
        if (this.removed_category.indexOf(d) === -1) {
          this.removed_category.push(d);
        }
      } else {
        var index = this.removed_category.indexOf(d);
        if (index > -1) {
          this.removed_category.splice(index, 1);
        }
        if (this.user_interest.indexOf(d) === -1) {
          this.user_interest.push(d);
        }
      }
      // console.log(this.user_interest)
      // console.log(this.removed_category)
    },

    _saveInterestList() {
      loader.style.display = "block";

      // Save Ids
      let url = `${process.env.API_BASE_URL}user/interest`,
        promiseOperation = [];

      if (this.user_interest.length > 0) {
        let body = {
            category_id: this.user_interest.join(),
            language_id: this.lang_id,
            device_name: window.navigator.platform
          },
          config = {
            headers: {
              auth_token: this.token
            }
          };

        promiseOperation.push(
          new Promise((resolve, reject) => {
            post(url, body, config)
              .then(res => {
                if (res.status === 200) {
                  resolve(res);
                }
              })
              .catch(error => {
                reject(error);
              });
          })
        );
      }
      if (this.removed_category.length > 0) {
        let bodyParams = {
            category_id: this.removed_category.join()
          },
          config = {
            data: bodyParams,
            headers: {
              auth_token: this.token
            }
          };
        promiseOperation.push(
          new Promise((resolve, reject) => {
            _delete(url, config)
              .then(res => {
                if (res.status === 200) {
                  resolve(res);
                }
              })
              .catch(error => {
                reject(error);
              });
          })
        );
      }

      Promise.all(promiseOperation)
        .then(values => {
          // console.info(values)
          loader.style.display = "none";
          this.$swal({
            title: this.$t("Saving Interest"),
            text: this.$t("Interest Saved Successfully!"),
            type: "success"
          }).then(() => {
            this.$router.push("/");
          });
        })
        .catch(err => {
          // console.log(err)
          loader.style.display = "none";
          this._errorHandler(err, "Error");
        });
    },

    _errorHandler(err, title, content) {
      if (!err) {
        this.$swal({
          title,
          text: content
            ? content
            : this.$t("Something went wrong, please try again later"),
          type: "warning"
        });
      } else {
        this.$swal({ title, text: err.response.message, type: "warning" });
      }
    }
  },

  // For Meta & Header Tag
  metaInfo() {
    return {
      title:
        this.$t("お気に入りの記事") + " | MATCHA - JAPAN TRAVEL WEB MAGAZINE",
      htmlAttrs: {
        lang: this.languageName
      },
      description: this.$t("footer.guide_text_short")
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/interest/index.vue